import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { SecurityGroup, ApprovalGroup, ApprovalGroupDto } from '@admin/models/system-configuration-model';
import { map } from 'rxjs';
import { SecurityGroupsHttpService } from './security-groups-http.service';

@Injectable({ providedIn: 'root' })
export class ApprovalGroupsHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
    private securityGroups: SecurityGroupsHttpService) { }

  getApprovalGroups(): Observable<ApprovalGroup[]> {
    const url = this.urlBuilder.getMojoApiUrl(`eas/getapprovalgroups`);
    return forkJoin(
      this.http.get<ApprovalGroupDto[]>(url),
      this.securityGroups.getSecurityGroups()
    ).pipe(
      map(([approvalGroups, securityGroups]) => {
        const results: ApprovalGroup[] = [];
        approvalGroups.forEach(dto =>
          results.push({
            Uri: dto.Uri,
            Name: dto.Name,
            IsDeletionAllowed: dto.IsDeletionAllowed,
            SecurityGroupCodes: this.codesToSecurityGroup(dto.SecurityGroupCodes, securityGroups)
          })
        );
        return results;
      })
    );
  }

  saveApprovalGroups(approvalGroups: ApprovalGroup[]): Observable<boolean> {
    const dtos: ApprovalGroupDto[] = [];
    approvalGroups.forEach(x => dtos.push({
      Uri: x.Uri,
      Name: x.Name,
      IsDeletionAllowed: x.IsDeletionAllowed,
      SecurityGroupCodes: this.securityGroupsToCodes(x.SecurityGroupCodes)
    }));

    const url = this.urlBuilder.getMojoApiUrl(`eas/saveapprovalgroups`);
    return this.http.post(url, dtos).pipe(
      map(res => true)
    );
  }

  private codesToSecurityGroup(codes: string[], groups: SecurityGroup[]): SecurityGroup[] {
    return groups.filter(x => codes.indexOf(x.Name) != -1);
  }

  private securityGroupsToCodes(groups: SecurityGroup[]): string[] {
    return groups.map(x => x.Name);
  }
}
